import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { usePreparedSchedule } from 'screens/Schedule/usePreparedSchedule'

export const useIsPostPromptsEnabled = ({ scheduleId }: { scheduleId: number }) => {
  const isPostPromptsFlagEnabled = useFlipperFlag('post_prompts')
  const { data } = usePreparedSchedule(
    { scheduleId },
    {
      enabled: isPostPromptsFlagEnabled,
    },
  )

  return isPostPromptsFlagEnabled && !!data?.has_post_prompts
}
